import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
// FIXME: T235847
// eslint-disable-next-line local-rules/validate-freelancer-imports
import type { Location } from '@freelancer/datastore/collections/project-view-users';

/**
 * Get the location of the user
 *
 * Usage: `{{ location | flLocation }}`
 */

@Pipe({ standalone: false, name: 'flLocation' })
export class LocationPipe implements PipeTransform {
  transform(location: Location): string {
    if (location && location.fullAddress) {
      return location.fullAddress;
    }

    if (location && location.country) {
      if (location.administrativeArea && location.city) {
        return `${location.city}, ${location.administrativeArea}, ${location.country.name}`;
      }

      if (location.city) {
        return `${location.city}, ${location.country.name}`;
      }

      if (location.administrativeArea) {
        return `${location.administrativeArea}, ${location.country.name}`;
      }
      return location.country.name;
    }

    if (location && location.city) {
      if (location.administrativeArea) {
        return `${location.city}, ${location.administrativeArea}`;
      }
      return location.city;
    }

    return '';
  }
}
